import { z } from 'zod';
import { PaginationSchema } from '../domain/pagination';

export const ValueSetSearchSchema = PaginationSchema.extend({
  search: z.string().optional(),
  isChronic: z.boolean().optional(),
  include: z.string().optional(),
});

export const SelectOptionSchema = z.object({
  value: z.string(),
  display: z.string(),
});

export type ValueSetSearchParams = z.infer<typeof ValueSetSearchSchema>;
export type SelectOption = z.infer<typeof SelectOptionSchema>;
